import React from "react";
import styled from "@emotion/styled";
import {
  fontFamily,
  fontSize,
  fontWeight,
  spacing,
  borderRadius,
  border as borderToken,
  interactive,
  surface,
  text,
} from "@atlas-int/tokens";
import type { ExportCategory } from "../packageRegistry";

interface ExportsListProps {
  categories: ExportCategory[];
}

const CategorySection = styled.div`
  margin-bottom: ${spacing[10]};
`;

const CategoryTitle = styled.h3`
  font-size: ${fontSize.lg};
  font-weight: ${fontWeight.semibold};
  color: ${text.primary};
  margin: 0 0 ${spacing[4]} 0;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: ${fontSize.sm};
`;

const Th = styled.th`
  text-align: left;
  padding: ${spacing[2]} ${spacing[4]};
  font-weight: ${fontWeight.semibold};
  color: ${text.secondary};
  border-bottom: 2px solid ${borderToken.default};
  white-space: nowrap;
`;

const Td = styled.td`
  padding: ${spacing[2]} ${spacing[4]};
  color: ${text.primary};
  border-bottom: 1px solid ${borderToken.subtle};
  vertical-align: top;
`;

const ExportName = styled.code`
  font-family: ${fontFamily.mono};
  font-size: ${fontSize.sm};
  font-weight: ${fontWeight.semibold};
  color: ${interactive.default};
`;

const KindBadge = styled.code`
  font-family: ${fontFamily.mono};
  font-size: ${fontSize.xs};
  padding: ${spacing[1]} ${spacing[2]};
  background-color: ${surface.muted};
  border-radius: ${borderRadius.base};
  color: ${text.secondary};
`;

const ExportsList: React.FC<ExportsListProps> = ({ categories }) => {
  return (
    <>
      {categories.map((category) => (
        <CategorySection key={category.name}>
          <CategoryTitle>{category.name}</CategoryTitle>
          <Table>
            <thead>
              <tr>
                <Th>Export</Th>
                <Th>Kind</Th>
                <Th>Description</Th>
              </tr>
            </thead>
            <tbody>
              {category.exports.map((exp) => (
                <tr key={exp.name}>
                  <Td>
                    <ExportName>{exp.name}</ExportName>
                  </Td>
                  <Td>
                    <KindBadge>{exp.kind}</KindBadge>
                  </Td>
                  <Td>{exp.description}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        </CategorySection>
      ))}
    </>
  );
};

export default ExportsList;
